import { useEffect } from "react";

export function useGlobalEventGoftino() {
  useEffect(() => {
    const originalDispatch = window.dispatchEvent;

    window.dispatchEvent = function (event: Event): boolean {
      const goftinoUserId = window?.Goftino?.getUserId();

      if (event.type === `goftino:disable_chat:${goftinoUserId}`) {
        const iframe = document.querySelector("iframe#goftino_w") as HTMLIFrameElement | null;
        if (iframe !== null && iframe !== undefined && iframe?.contentDocument !== undefined) {
          const textarea = iframe?.contentDocument?.querySelector(
            "textarea.form-control",
          ) as HTMLTextAreaElement | null;
          if (textarea) {
            textarea.disabled = true;
          }
        }
      }
      if (event.type === `goftino:enable_chat:${goftinoUserId}`) {
        const iframe = document.querySelector("iframe#goftino_w") as HTMLIFrameElement | null;

        if (iframe !== null && iframe !== undefined && iframe?.contentDocument !== undefined) {
          const textarea = iframe?.contentDocument?.querySelector(
            "textarea.form-control",
          ) as HTMLTextAreaElement | null;
          if (textarea) {
            if (textarea) {
              textarea.disabled = false;
            }
          }
        }
      }

      return originalDispatch.call(this, event);
    };

    return () => {
      window.dispatchEvent = originalDispatch;
    };
  }, []);
}
